import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import enLang from 'element-ui/lib/locale/lang/en'
import "element-ui/lib/theme-chalk/index.css";
import "./style.css";
import './plugins/filters'

Vue.config.productionTip = false;
Vue.use(ElementUI,{
  size: 'medium', 
  locale: enLang 
});

import http from "./http";
Vue.prototype.$http = http;
Vue.mixin({
  computed: {
    uploadUrl() {
      return this.$http.defaults.baseURL + "/upload";
    }
  },
  methods: {
    getAuthHeaders() {
      return {
        Authorization: `Bearer ${localStorage.token || ""}`
      };
    }
  }
});

new Vue({
  router,
  render: h => h(App),
}).$mount("#app");
